import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ChatSidebar from "./ChatSidebar";
import ChatWindow from "./ChatWindow";
import { setWidgetState } from "../../../Slices/chatSlice";
import "./chatWidget.css";

const ChatPage = () => {
  const dispatch = useDispatch();

  // Close widget when on fullscreen page
  useEffect(() => {
    dispatch(setWidgetState("closed"));
  }, [dispatch]);

  return (
    <div className="chat-fullscreen">
      <ChatSidebar mode="fullscreen" />
      <ChatWindow mode="fullscreen" />
    </div>
  );
};

export default ChatPage;
